import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  selectItemById,
  selectItemsIds,
  selectPagination,
  selectRequestState,
  selectQueryParams,
  sendRequest,
  changeDefaultQueryParams,
  changeQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import UserOutputCashHistoryTableItem from './UserOutputCashHistoryTableItem';
import PaginationBlock from '../../Common/Pagination/PaginationBlock/PaginationBlock';
import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';
import SortLabelColumnToggle from '../../Common/Inputs/SortLabelColumnToggle';

class UserOutputCashHistoryTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultQueryParams: {
        page: '1',
        sort: '-created_at'
      }
    };
    this.props.changeDefaultQueryParams(this.state.defaultQueryParams);
    this.props.sendRequest();
  }

  render() {
    const awaitConfirmByOwnerExist = !!this.props.itemsIds.find(itemId => {
      const item = this.props.selectItemById(itemId);
      return item.status === 6;
    });
    let items = null;
    if (this.props.itemsIds.length > 0) {
      items = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            <UserOutputCashHistoryTableItem
              key={`UserOutputCashHistoryTableItem${itemId}`}
              item={this.props.selectItemById(itemId)}
              onRefreshOutputCashHistoryTable={() => this.props.sendRequest()}
              awaitConfirmByOwnerExist={awaitConfirmByOwnerExist}
            />
          ))}
        </React.Fragment>
      );
    } else {
      items = (
        <tr>
          <td className="text-center" colSpan="5">
            {t('Записи не найдены')} :-(
          </td>
        </tr>
      );
    }
    return (
      <React.Fragment>
        <div>
          {this.props.requestState.inProgress ? <OpacityPreLoader /> : null}
          <div className="table-responsive">
            <table className="table table-sortible table-hover m-b-0">
              <thead>
                <tr>
                  <SortLabelColumnToggle
                    label={t('Дата')}
                    tag="th"
                    defaultValue="created_at"
                    selectedValue={this.props.selectQueryParams.sort}
                    handleChangeSortValue={sortValue => {
                      this.props.changeQueryParams({
                        sort: sortValue
                      });
                      this.props.sendRequest();
                    }}
                  />
                  <th className="text-nowrap">{t('# заявки')}</th>
                  <th>{t('Статус')}</th>
                  <th>{t('Описание')}</th>
                  <SortLabelColumnToggle
                    label={`${t('Сумма')}, <i class="fa fa-rub" />`}
                    tag="th"
                    defaultValue="total_sum"
                    className="text-nowrap text-right"
                    selectedValue={this.props.selectQueryParams.sort}
                    handleChangeSortValue={sortValue => {
                      this.props.changeQueryParams({
                        sort: sortValue
                      });
                      this.props.sendRequest();
                    }}
                  />
                  {awaitConfirmByOwnerExist ? (
                    <th style={{ maxWidth: '80px' }} />
                  ) : null}
                </tr>
              </thead>
              <tbody>{items}</tbody>
            </table>
          </div>
          <div className="table-footer">
            <PaginationBlock
              paginationData={this.props.pagination}
              handlePageClick={pageNumber => {
                this.props.changeQueryParams({ page: pageNumber });
                this.props.sendRequest();
              }}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

UserOutputCashHistoryTable.propTypes = {
  // CONNECT
  changeDefaultQueryParams: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  selectQueryParams: PropTypes.shape({
    sort: PropTypes.string
  }).isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,

  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestState(state, props.listReduceName),
  pagination: selectPagination(state, props.listReduceName),
  itemsIds: selectItemsIds(state, props.listReduceName),
  selectItemById: id => selectItemById(state, props.listReduceName, id),
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserOutputCashHistoryTable);



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashHistoryTable/UserOutputCashHistoryTable.js